import React from 'react';
import Link from 'components/common/Link';
import { Box, Alert, AlertTitle } from '@mui/material';

const MassImportLink = ({ type }: { type: string }) => {
  return (
    <Box>
      <Alert severity="info">
        <AlertTitle> Need to add multiple {type.toLocaleLowerCase()}? </AlertTitle>
        <Link href={`/settings/mass-import?type=${type}`}>Go to mass import</Link>
      </Alert>
    </Box>
  );
};

export default MassImportLink;
